// extracted by mini-css-extract-plugin
export default {"drawer":"GS","drawerheader":"HS","retake_quiz_bottom_bar":"IS","extra_drawer":"JS","not_answered_questions":"KS","question_ui":"LS","accordion_details":"MS","retake_quiz":"NS","accordions":"OS","accordion_root":"PS","accordion_summary_text":"QS","animation":"RS","show_animation":"SS","overflow_hidden":"TS"};
    if(module.hot) {
      // 1715276859454
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  